import { useState, useEffect } from 'react';

const imageCache = new Map();

export const useCachedImage = (src) => {
  const [image, setImage] = useState(() => imageCache.get(src) || null);

  useEffect(() => {
    if (!src) return;

    if (imageCache.has(src)) {
      setImage(imageCache.get(src));
      return;
    }

    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = src;
    img.onload = () => {
      imageCache.set(src, img);
      setImage(img);
    };
  }, [src]);

  return image;
};
